$(document).ready(function() {
  const MAX_24BIT = 16777215;
  $(document).on("cocoon:after-insert", "#user-pic-company-form", function (e, insertedItem) {
    $(".icon-remove-user-company").removeClass("d-none");
  });

  $(document).on("cocoon:after-remove", "#user-pic-company-form", function (e, insertedItem) {
    detectHideRemovePicUserCompany();
  });

  function toggleCheckboxes() {
    const $clientCheckbox = $('.client-checkbox');
    const $partnerCheckbox = $('.partner-checkbox');
    const $leaseCheckbox = $('.lease-checkbox');

    const isClientChecked = $clientCheckbox.prop('checked');
    const isPartnerChecked = $partnerCheckbox.prop('checked');
    const isLeaseChecked = $leaseCheckbox.prop('checked');

    const isClientSaved = $clientCheckbox.data('saved');
    const isPartnerSaved = $partnerCheckbox.data('saved');
    const isLeaseSaved = $leaseCheckbox.data('saved');

    $clientCheckbox.prop('disabled', isLeaseChecked || (isClientChecked && isClientSaved));
    $partnerCheckbox.prop('disabled', isLeaseChecked || (isPartnerChecked && isPartnerSaved));
    $leaseCheckbox.prop('disabled', isClientChecked || isPartnerChecked || (isLeaseChecked && isLeaseSaved));

    const partnerBoxes = $('.apl-box, .pca-box, .partner-closing-day-box, .partner-payment-month-type-box, .partner-payment-day-box, .partner-kintone-code-box, .partner-type-ids-box, .partner-pay-status-box');
    const clientFields = $('.client-receive, .closing-day, .pay-status, .partner-closing-day, .partner-payment-types, .rakuraku-checkbox');
    showHideClosingDay(isLeaseChecked)
    if (isLeaseChecked) {
      partnerBoxes.hide();
      clientFields.prop('disabled', false);
      $('input[name="company[client_company_attributes][is_rakuraku]"]').prop('disabled', false);
      $('.btn-add-bank').removeClass('disabled');
      toggleLeaseDepositOption(true);
      if (!isLeaseSaved) {
        $('.payment-types option[value="lease_deposit"]').show().prop('selected', true).trigger('change');
      }
      $('#company_partner_company_attributes_id').prop('disabled', false);
      $('#hidden_is_client_company').val(false);

    } else {
      partnerBoxes.show();
      clientFields.prop('disabled', true);
      $('.btn-add-bank').addClass('disabled');
      $('.payment-types option[value="lease_deposit"]').show().prop('selected', false).trigger('change');
      if (isPartnerChecked) $('.rakuraku-checkbox').prop('disabled', true);
      toggleLeaseDepositOption(false);
      if (isClientChecked && !isPartnerChecked) {
        $('#company_partner_company_attributes_id').prop('disabled', true);
        if (!isClientSaved) {
          $('.payment-types option[value="transfer_deposit"]').show().prop('selected', true).trigger('change');
        }
      }
      formState($('.client-form'), $('#company_is_client_company').is(':checked'));
      formState($('.partner-company-form'), $('#company_is_partner_company').is(':checked'));
    }
  }

  function showHideClosingDay(isLeaseChecked) {
    const $client = $('.closing-day-client');
    const $lease = $('.closing-day-lease');

    if (isLeaseChecked) {
      $lease.show().next('.select2-container').show();
      $client.hide().next('.select2-container').hide();
    } else {
      $client.show().next('.select2-container').show();
      $lease.hide().next('.select2-container').hide();
    }
  }

  $('#closing_day_client, #closing_day_lease').on('change', function () {
    syncClosingDay();
  });

  function syncClosingDay() {
    var selected = $('#closing_day_client').is(':visible') ? $('#closing_day_client').val() : $('#closing_day_lease').val();
    $('#closing-day-hidden').prop('disabled', false);
    $('#closing-day-hidden').val(selected);
  }

  $('#payment_day, #payment_month_type').on('change', function () {
    syncClientPaymentSiteFields();
  });

  function setSelect2FromHidden($select, hiddenVal) {
    if (!hiddenVal || $select.val()) return;

    const strVal = String(hiddenVal);
    if ($select.find(`option[value="${strVal}"]`).length) {
      $select.val(strVal).trigger('change.select2');
    }
  }

  function initClientPaymentSiteFields() {
    setSelect2FromHidden($('#payment_day'), $('#payment-day-hidden').val());
    setSelect2FromHidden($('#payment_month_type'), $('#payment-month-type-hidden').val());
    syncClientPaymentSiteFields();
  }

  function syncClientPaymentSiteFields() {
    $('#payment-day-hidden')
      .prop('disabled', false)
      .val($('#payment_day').val() || '');
    $('#payment-month-type-hidden')
      .prop('disabled', false)
      .val($('#payment_month_type').val() || '');
  }

  function toggleLeaseDepositOption(show) {
    const $select = $('.payment-types');
    const $option = $select.find('option[value="lease_deposit"]');

    $option.prop('disabled', !show);

    if (!show && $select.val() === 'lease_deposit') {
      $select.val('').trigger('change.select2');
    } else {
      $select.trigger('change.select2');
    }
  }

  $(document).on('change', '.client-checkbox, .partner-checkbox, .lease-checkbox', function() {
    if (!$(this).is(':checked')) {
      const hasProjects = $(this).data('has-projects');
      if (hasProjects) {
        alert("この会社には既にプロジェクトがあるため、チェックを外すことはできません。");
        $(this).prop('checked', true);
      }
    }
  });



  $(function() {
    toggleCheckboxes();

    $('.client-checkbox, .partner-checkbox, .lease-checkbox').change(function() {
      toggleCheckboxes();
    });
  });

  function bindValueForBankForm($container) {
    let bank_branch_id = $container.find('.bank_branch_id').attr('selected_id');
    let bankId = $container.find('.partner-company-bank-id').attr('selected_id')
    let is_temporary = $container.find('.is_temporary').attr('value');

    if (is_temporary.length > 0) {
      $container.find(`.is_temporary input[value=${is_temporary}]`).prop('checked', true);
    }

    let isDefault = $container.find('.is_default_wrapper').attr('value');
    $container.find('.is-default-checkbox').prop('checked', isDefault === 'true');

    setTimeout(() => {
      $container.find('.partner-company-bank-id select').val(bankId).change();
    }, 100);

    setTimeout(() => {
      $container.find('.bank_branch_id select').val(bank_branch_id).change();
    }, 600);
  }

  detectHideRemovePicUserCompany();

  const CLIENT_PAYMENT_SITE_HIDDEN = '#payment-day-hidden, #payment-month-type-hidden';

  function formState($form, isActive = true) {
    if (isActive) {
      $form.find('input').prop('disabled', false);
      $form.find('select').prop('disabled', false);
      $form.find('a').removeClass('disabled');
    } else {
      $form.find('a').addClass('disabled');
      $form.find('input').not(CLIENT_PAYMENT_SITE_HIDDEN).prop('disabled', true);
      $form.find('select').prop('disabled', true);
    }

    syncClientPaymentSiteFields();
    $form.find('#company_client_company_attributes_kintone_code').prop('disabled', true);
    $form.find('#company_client_company_attributes_rakuraku_code').prop('disabled', true);
    $form.find('#_hidden_field_client_kinton_code').prop('disabled', false);
    $form.find('#_hidden_field_client_rakuraku_code').prop('disabled', false);
    $form.find('#company_partner_company_attributes_kintone_code').prop('disabled', true);
    updatePartnerPaymentMonthType();
  }
  window.formState = formState;
  window.bindValueForBankForm = bindValueForBankForm;

  if ($('.companies-form').length > 0) {
    setTimeout(() => {
      $(`#bank_data > .display-data-temp`).each(function () {
        bindValueForBankForm($(this).find('.temp-form'))
      })
    }, 200);
  }

  if ($('.companies-form').length > 0) {
    formState($('.client-form'), $('#company_is_client_company').is(':checked'))
    // if ($('#company_is_client_company').is(':checked')) {
    //   $('.client-form').find(".client_company_kintone_code").removeClass('d-none');
    // } else {
    //   $('.client-form').find(".client_company_kintone_code").addClass('d-none');
    // }
    formState($('.partner-company-form'), $('#company_is_partner_company').is(':checked'))
    syncClosingDay();
    setTimeout(initClientPaymentSiteFields, 0);
  }

  $(document).on('submit', '.companies-form form.form-enter-tab', function () {
    syncClosingDay();
    syncClientPaymentSiteFields();
    $(CLIENT_PAYMENT_SITE_HIDDEN).prop('disabled', false);
  });

  function detectHideRemovePicUserCompany() {
    if ($(".wrap-pic-user-company").length == 1) {
      $(".icon-remove-user-company").addClass("d-none");
    }
  }

  $(document).on('change', '.parent_company_sel', function () {
    if ($(this).val() == '') {
      $(this).closest('.row').find('#company_bill_this_company').attr('disabled', true).attr('checked', false);
    } else {
      $(this).closest('.row').find('#company_bill_this_company').attr('disabled', false);
    }
  })

  $(document).on('change', '.company_id', function () {
    var company_id = $(this).val();
    var element = $('#parent_company');
    $.ajax({
      method: "get",
      dataType: 'json',
      url: `/companies/${company_id}/get_parent_companies`,
      success: function (e) {
        $(element).empty();
        let data = e.companies.map(function (item) {
          return { id: item.id, text: item.name }
        })

        $(element).select2({
          width: '100%',
          theme: 'bootstrap',
          placeholder: '選択してください',
          allowClear: true,
          data: data,
          language: {
            noResults: function () {
              return '見つかりません。';
            },
          },
          dropdownParent: $('#modal-bank-form')
        });
        if (e.parent_company != '') {
          $(element).val(e.parent_company).change();
        }
      }
    })
  })

  $(document).on('click', '#partner-company-bank-form .is_temporary input', function () {
    let isTemporary = $(this).closest('span').text()
    $(this).closest('.is_temporary').attr('value', $(this).val())
    $(this).closest('#partner-company-bank-form').find('.is_temporary_val').text(isTemporary);
  })

  $(document).on('change', '#partner-company-bank-form .is-default-checkbox', function () {
    let isDefault = $(this).prop('checked');
    $(this).closest('.is_default_wrapper').attr('value', isDefault ? 'true' : 'false');
    $(this).closest('#partner-company-bank-form').find('.is-default-display').toggle(isDefault);
  })

  function clearOtherDefaultBanks(currentFormId) {
    $(`#bank_data > .display-data-temp`).each(function () {
      if (String($(this).attr('form-id')) === String(currentFormId)) return;

      $(this).find('.is-default-display').hide();
      $(this).find('.is_default_wrapper').attr('value', 'false');
      $(this).find('.is-default-checkbox').prop('checked', false).removeAttr('checked');

      let $tempForm = $(this).children('.temp-form');
      let formHtml = $tempForm.attr('form-html');
      if (!formHtml) return;

      if ($tempForm.attr('escaped_html') == 'true') {
        formHtml = $('<div/>').html(formHtml).text();
      }
      let $parsed = $('<div/>').html(formHtml);
      $parsed.find('.is_default_wrapper').attr('value', 'false');
      $parsed.find('.is-default-checkbox').prop('checked', false).removeAttr('checked');
      $tempForm.attr('form-html', $parsed.html());
      $tempForm.attr('escaped_html', false);
    });
  }
  window.clearOtherDefaultBanks = clearOtherDefaultBanks;

  $(document).on('change', '#partner-company-bank-form .name_kanji input', function () {
    let name_kanji = $(this).val();
    $(this).attr('value', name_kanji)
    $(this).closest('#partner-company-bank-form').find('.transfer-name-kanji').text(name_kanji);
  })

  function applyTransferNameKanaFullWidth($input) {
    const converted = window.applyFullWidthToInput($input);
    $input.attr('value', converted);
    $input.closest('#partner-company-bank-form').find('.transfer-name-kana').text(converted);
    return window.syncFullwidthFieldError($input);
  }

  $(document).on('input', '#partner-company-bank-form .name_kana', function (event) {
    if (event.originalEvent && event.originalEvent.isComposing) return;
    applyTransferNameKanaFullWidth($(this));
  })

  $(document).on('compositionend', '#partner-company-bank-form .name_kana', function () {
    applyTransferNameKanaFullWidth($(this));
  })

  $(document).on('change', '#partner-company-bank-form .name_kana', function () {
    applyTransferNameKanaFullWidth($(this));
  })

  $(document).on('change', '#partner-company-bank-form .account_number', function () {
    let accountNumber = $(this).val();
    $(this).attr('value', accountNumber)
    $(this).closest('#partner-company-bank-form').find('.account-number').text(accountNumber);
  })

  $(document).on('change', '#partner-company-bank-form .bank_branch_id select', function () {
    let branchName = $(this).find('option:selected').text();
    $(this).closest('.bank_branch_id').attr('selected_id', $(this).val())
    $(this).closest('#partner-company-bank-form').find('.branch-name').text(branchName);
  })

  $(document).on('change', '.partner-company-bank-id select', function () {
    let bank_id = $(this).val();
    $(this).closest('.partner-company-bank-id').attr('selected_id', $(this).val())
    let bankName = $(this).find('option:selected').text();
    $(this).closest('#partner-company-bank-form').find('.bank-name').text(bankName);
    var $element = $(this)

    $.ajax({
      url: `/banks/${bank_id}/branches`,
      type: 'GET',
      success: function (e) {
        let data = e.branches.map(function (item) {
          return { id: item[0], text: item[1] }
        })

        $bank_branch_id = $element.closest('#modal-bank-form').find('.bank_branch_id select');
        // clear old options
        $bank_branch_id.empty();
        $bank_branch_id.select2({
          width: '100%',
          theme: 'bootstrap',
          placeholder: '選択してください',
          allowClear: true,
          data: data,
          language: {
            noResults: function () {
              return '見つかりません。';
            },
          },
          dropdownParent: $('#modal-bank-form')
        });

        $bank_branch_id.val('').change();
      }
    });
  });

  $(document).on('change', '.position-company-type', function() {
    updateCustomerDisplayName();
  })

  $(document).on('change input', '#company_name', function() {
    updateCustomerDisplayName();
  })

  $(document).on('change input', '#company_office_name', function() {
    updateCustomerDisplayName();
  })

  function updateCustomerDisplayName() {
    var abbreviation = $('#company_type_id').find('option:selected').data('abbreviation');
    var company_type = $('#company_type_id').find('option:selected').val();
    var company_text = $('#company_type_id').find('option:selected').text();
    var position = $('#juridical_personality_position').find('option:selected').val();
    var code = $('#company_code_base').val();
    var name = $('#company_name').val();
    var office_name = $('#company_office_name').val();
    var name_base = $('#name_base').val() || name;
    var display_name = name_base;
    // Build display name with juridical personality
    if (position && company_type) {
      switch(position) {
        case 'prefix':
          code = `${code} ${abbreviation} ${name}`;
          display_name = `${company_text} ${name_base}`;
          break;
        case 'appendix':
          code = `${code} ${name} ${abbreviation}`;
          display_name = `${name_base} ${company_text}`;
          break;
        default:
          display_name = name_base;
          code = `${code} ${display_name}`;
          break;
      }
    }else{
      code = `${code} ${display_name}`;
    }
    // Add office name at the end if it exists
    if (office_name && office_name.trim() !== '') {
      display_name = `${display_name}   ${office_name.trim()}`;
      code = `${code}   ${office_name.trim()}`;
    }

    $('#company_company_code').val(code);
    $('#company_code').val(code);
    $('#company_company_name').val(display_name);
    $('#company_display_name').val(display_name);
  }

  $(document).on('change', '.legal_change', function() {
    var name = $('#current_name').val();
    var position = $('#main_company_juridical_personality_position').find('option:selected').val();
    var company_type = $('#company_type_id').find('option:selected').val();
    var company_name = '';
    if (position && company_type) {
      switch(position) {
        case 'prefix':
          company_name = `${company_type} ${name}`;
          $('#main_company_name').val(company_name)
          break;
        case 'appendix':
          company_name = `${name} ${company_type}`;
          $('#main_company_name').val(company_name)
          break;
        default:
          $('#main_company_name').val(name)
          break;
      }
    }
  })

  $(document).on('change', '#main_company_name', function() {
    var position = $('#main_company_juridical_personality_position').find('option:selected').val();
    var company_type = $('#company_type_id').find('option:selected').val();
    var company_name = $(this).val();
    var base_name = company_name;
    if (position && company_type) {
      switch(position) {
        case 'prefix':
          base_name = company_name.split(" ").slice(1).join(" ");
          break;
        case 'appendix':
          base_name = company_name.split(" ").slice(0, -1).join(" ");
          break;
        default:
          break;
      }
    }
    $('#current_name').val(base_name)
})

// Disabled auto-fill behavior for payment fields as per task #138121
// $(document).on('change', '.form-common-page #payment_type', function () {
//   var value = $(this).val();
//   if (value == 'transfer_deposit') {
//     $('.form-common-page #company_partner_company_attributes_payment_day').val('99').change();
//     $('.form-common-page #partner_payment_month_type').val('this_month').change();
//   } else if (value == 'direct_debit') {
//     $('.form-common-page #company_partner_company_attributes_payment_day').val('27').change();
//   } else {
//     $('.form-common-page #company_partner_company_attributes_payment_day').val('').change();
//     $('.form-common-page #partner_payment_month_type').val('').change();
//   }
// })

  $(document).on('input', '.input-kanji-only', function () {
    this.value = this.value.replace(/[^一-龯]/g, '');
  });

$(document).on('input', '.input-kanji-only', function () {
  this.value = this.value.replace(/[^一-龯]/g, '');
});

$(document).on('input', '.input-kana-only', function () {
  this.value = this.value.replace(/[^ぁ-んァ-ン]/g, '');
});

$(document).on('click', '.form-common-page .btn-add-bank', function () {
  let formId = Math.floor(Math.random() * MAX_24BIT)
  $('#modal-bank-form').data('mode', 'create');
  $('#modal-bank-form').data('formId', formId);
  $('#modal-bank-form').modal('show');
});

$(document).on('hidden.bs.modal', '#modal-bank-form', function () {
  $('#partner-company-bank-form').html('')
});

$(document).on('click', '#modal-bank-form-submit', function (event) {
  event.preventDefault();
  let hasHalfwidthKana = false;
  $('#partner-company-bank-form .name_kana').each(function () {
    if (applyTransferNameKanaFullWidth($(this))) hasHalfwidthKana = true;
  });
  if (hasHalfwidthKana) return;
  // get all input in form
  let formId = $('#partner-company-bank-form .display-data-temp').attr('form-id');
  $('#partner-company-bank-form select').each(function () {
    if ($(this).data('select2')) {
      $(this).select2('destroy');
    }
  });
  let $existForm = $(`#bank_data > .display-data-temp[form-id=${formId}]`);
  if ($existForm.length > 0) {
    $existForm.html($('#partner-company-bank-form .temp-container .display-data-temp').html());
  } else {
    htmlValueDisplay = $('#partner-company-bank-form .temp-container').html()
    $('#bank_data').append(htmlValueDisplay)
  }
  let rawFormHtml = $('#partner-company-bank-form').html();
  $tempForm = $(`#bank_data .display-data-temp[form-id=${formId}] > .temp-form`)
  $tempForm.attr('form-html', rawFormHtml);
  $tempForm.attr('escaped_html', false);
  $tempForm.html(rawFormHtml)

  $tempForm.find('select').each(function () {
    if (!$(this).data('select2')) {
      $(this).select2();
    }
  });

  bindValueForBankForm($tempForm)

  const isDefault = $(`#bank_data .display-data-temp[form-id=${formId}] .is_default_wrapper`).attr('value') === 'true';
  if (isDefault) {
    clearOtherDefaultBanks(formId);
  }

  $('#modal-bank-form').modal('hide');
})

  $(document).on('click', '.form-common-page .btn-add-bank', function () {
    let formId = Math.floor(Math.random() * MAX_24BIT);

    let isLeaseChecked = $('.lease-checkbox').prop('checked');

    $('#modal-bank-form')
      .data('mode', 'create')
      .data('formId', formId)
      .one('shown.bs.modal', function () {
        showHideClosingDay(isLeaseChecked);
      });

    $('#modal-bank-form').modal('show');
  });

  $(document).on('hidden.bs.modal', '#modal-bank-form', function () {
    $('#partner-company-bank-form').html('')
  });


$(document).on('click', '#bank_data .btn-edit', function () {
  let $container = $(this).closest('.display-data-temp').find('.temp-form')
  let formHtml = $container.attr('form-html')
  if ($container.attr('escaped_html') == 'true') {
    formHtml = $('<div/>').html(formHtml).text()
  }

  let formId = Math.floor(Math.random() * MAX_24BIT)
  $(this).closest('.display-data-temp').attr('form-id', formId);
  $('#partner-company-bank-form').html(formHtml);
  $('#partner-company-bank-form select').each(function () {
    if (!$(this).hasClass('select2-hidden-accessible')) {
      $('#partner-company-bank-form select').select2({
        width: "100%",
        theme: "bootstrap",
        placeholder: "選択してください",
        allowClear: true,
        language: {
          noResults: function () {
            return '見つかりません。';
          },
        },
        dropdownParent: $('#modal-bank-form')
      });
    }
  });
  bindValueForBankForm($('#partner-company-bank-form'))
  $('#modal-bank-form').modal('show');
  $('#partner-company-bank-form .display-data-temp').attr('form-id', formId);
})

$(document).on('click', '#bank_data .btn-delete', function () {
  $(this).closest('.display-data-temp').hide()
  // find destroy-checkbox and checked
  $(this).closest('.display-data-temp').find('.temp-form .destroy-checkbox').attr('value', 'true')
})

$(document).on('change', '#company_is_partner_company', function () {
  let $form = $('.partner-company-form')
  formState($form, $(this).is(':checked'))
})

$(document).on('change', '#company_is_client_company', function () {
  let $form = $('.client-form')
  formState($form, $(this).is(':checked'))
  $form.find(".client_company_kintone_code").removeClass('d-none');
})

$(document).on('change', '.company_client_company_client_receive_id .select2', function () {
  if($(this).val() !== '') {
    $.ajax({
      method: "get",
      dataType: 'json',
      url: `/client_companies/${$(this).val()}`,
      success: function (e) {
        const isLeaseChecked = $('.lease-checkbox').prop('checked');
        const paymentType = isLeaseChecked ? 'lease_deposit' : e.payment_type;
        $('.company_client_company_apl .select2').val(e.apl).change();
        $('.company_client_company_pca .select2').val(e.pca).change();
        if(!isLeaseChecked) $('#closing_day_client').val(e.closing_day).change();
        $('.company_client_company_payment_type .select2').val(paymentType).change();
        $('#payment_day').val(e.payment_day != null ? String(e.payment_day) : '').change();
        $('#payment_month_type').val(e.payment_month_type != null ? String(e.payment_month_type) : '').change();
        $('.company_client_company_pay_status .select2').val(e.pay_status).change();
        $('#_hidden_field_client_kinton_code').val(e.kintone_code);
        $('#_hidden_field_client_rakuraku_code').val(e.rakuraku_code);
        $('#company_client_company_attributes_kintone_code').val(e.kintone_code);
        $('#company_client_company_attributes_rakuraku_code').val(e.rakuraku_code);
        $('#company_client_company_attributes_is_rakuraku').prop('checked', e.is_rakuraku);
      }
    })
  } else {
    const isLeaseChecked = $('.lease-checkbox').prop('checked');
    const $closingDayTarget = isLeaseChecked ? $('#closing_day_lease') : $('#closing_day_client');

    $('.company_client_company_apl .select2').val(null).change();
    $('.company_client_company_pca .select2').val(null).change();
    $closingDayTarget.val('99').change();
    $('.company_client_company_payment_type .select2').val(isLeaseChecked ? 'lease_deposit' : 'transfer_deposit').change();
    $('#payment_day').val('99').change();
    $('#payment_month_type').val('next_month').change();
    $('.company_client_company_pay_status .select2').val(null).change();
    var companycode = $('#company_company_code').val();
    $('#_hidden_field_client_kinton_code').val('');
    $('#company_client_company_attributes_kintone_code').val('');
    $('#_hidden_field_client_rakuraku_code').val('CL-' + parseInt(companycode.split(' ')[0]));
    $('#company_client_company_attributes_rakuraku_code').val('CL-' + parseInt(companycode.split(' ')[0]));
    $('#company_client_company_attributes_is_rakuraku').prop("checked", false)
  }
})

function initBankModalSelect2() {
  const $selects = $('#partner-company-bank-form .partner-company-bank-id select, #partner-company-bank-form .bank_branch_id select');
  const select2Options = {
    width: "100%",
    theme: "bootstrap",
    placeholder: "選択してください",
    allowClear: true,
    language: {
      noResults: function () {
        return '見つかりません。';
      },
    },
    dropdownParent: $('#modal-bank-form')
  };

  $selects.each(function () {
    const $select = $(this);
    if ($select.hasClass('select2-hidden-accessible')) return;
    $select.select2(select2Options);
    $select.next('.select2-container').css('visibility', 'visible');
  });
}

// Hide native selects as soon as cocoon inserts them, before the modal becomes visible.
$(document).on('cocoon:after-insert', '#partner-company-bank-form', function (e, insertedItem) {
  $(insertedItem).find('.partner-company-bank-id select, .bank_branch_id select').css('visibility', 'hidden');
});

$(document).ready(function() {
  // Hide native selects before the modal is painted to avoid a flash.
  $('#modal-bank-form').on('show.bs.modal', function () {
    if ($(this).data('mode') === 'create') {
      $('#partner-company-bank-form .partner-company-bank-id select, #partner-company-bank-form .bank_branch_id select')
        .css('visibility', 'hidden');
    }
  });

  $('#modal-bank-form').on('shown.bs.modal', function () {
    const mode = $(this).data('mode');
    const formId = $(this).data('formId');
    if (mode === 'create') {
      $('#partner-company-bank-form .display-data-temp').attr('form-id', formId);

      // Auto-check デフォルト when there is no visible default bank
      // (no banks at all, or all existing banks have デフォルト unchecked).
      const hasDefaultBank = $('#bank_data > .display-data-temp').filter(function () {
        if ($(this).css('display') === 'none') return false;
        return $(this).find('.is_default_wrapper').attr('value') === 'true';
      }).length > 0;

      if (!hasDefaultBank) {
        $('#partner-company-bank-form .is-default-checkbox').prop('checked', true);
        $('#partner-company-bank-form .is_default_wrapper').attr('value', 'true');
        $('#partner-company-bank-form .is-default-display').show();
      }

      initBankModalSelect2();
    }
  });

  $('#modal-bank-form').on('hidden.bs.modal', function () {
    $(this).removeData('mode');
  });

  updatePartnerPaymentMonthType();
})

$(document).on('change', '#partner_payment_month_type', function () {
  updatePartnerPaymentMonthType(true);
})

function updatePartnerPaymentMonthType(isChangePaymentMonthType= false) {
  const isPartnerChecked = $('.partner-checkbox').prop('checked');
  let paymentMonth = $('.company_partner_company_payment_month_type #partner_payment_month_type').val();
  if (paymentMonth === 'current_day' || paymentMonth === '') {
    $('#company_partner_company_attributes_payment_day').val('').change();
    $('#company_partner_company_attributes_payment_day').prop('disabled', true);
  } else {
    $('#company_partner_company_attributes_payment_day').prop('disabled', !isPartnerChecked);
  }
}
})
